import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuth } from '../lib/auth';
import { homePath } from '../lib/home';
import { formatError } from '../lib/errors';

const MIN_PASSWORD_LENGTH = 8;

export function SetPasswordScreen() {
  const { session, signOut, markPasswordSet, can } = useAuth();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);

    if (password.length < MIN_PASSWORD_LENGTH) {
      setError(`Wachtwoord moet minimaal ${MIN_PASSWORD_LENGTH} tekens zijn.`);
      return;
    }
    if (password !== confirm) {
      setError('De twee wachtwoorden komen niet overeen.');
      return;
    }

    setBusy(true);
    const { error: updateErr } = await supabase.auth.updateUser({ password });
    setBusy(false);
    if (updateErr) {
      setError(formatError(updateErr));
      return;
    }
    markPasswordSet();
    navigate(homePath(can), { replace: true });
  };

  return (
    <div className="login-shell">
      <div className="login-card">
        <h1>Wachtwoord instellen</h1>
        <p className="muted">
          {session?.user?.email ? (
            <>Welkom <strong>{session.user.email}</strong>. Stel een wachtwoord in om je account te activeren.</>
          ) : (
            <>Stel een wachtwoord in om je account te activeren.</>
          )}
        </p>

        <form onSubmit={submit} className="login-form">
          <label>
            <span>Nieuw wachtwoord</span>
            <input
              type="password"
              autoComplete="new-password"
              required
              minLength={MIN_PASSWORD_LENGTH}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          <label>
            <span>Herhaal wachtwoord</span>
            <input
              type="password"
              autoComplete="new-password"
              required
              minLength={MIN_PASSWORD_LENGTH}
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
            />
          </label>
          {error ? <div className="login-error">{error}</div> : null}
          <button type="submit" className="btn-primary" disabled={busy}>
            {busy ? 'Bezig…' : 'Opslaan en doorgaan'}
          </button>
          <button
            type="button"
            className="btn-link"
            onClick={() => void signOut()}
          >
            Uitloggen
          </button>
        </form>
      </div>
    </div>
  );
}
